import { IconButton, InputAdornment, useTheme } from "@mui/material"
import React from "react"
import PropTypes from "prop-types"
import { TextFieldInputStyled } from "./text-field-input.styled"

const TextFieldInput = ({
    type = "text",
    label,
    startIcon,
    endIcon,
    onEndIconClick = () => {},
    error = false,
    helperText = "",
    value,
    InputLabelProps: inputLabelProps,
    InputProps: inputProps,
    inputProps: nativeInputProps,
    onFocus: onFocusProp,
    onBlur: onBlurProp,
    ...props
}) => {
    const theme = useTheme()

    const [focus, setFocus] = React.useState(false)
    const hasValue = value !== undefined && value !== null && `${value}` !== ""

    const handleFocus = (event) => {
        setFocus(true)
        if (onFocusProp) onFocusProp(event)
    }

    const handleBlur = (event) => {
        setFocus(false)
        if (onBlurProp) onBlurProp(event)
    }

    const mergedInputProps = {
        ...(inputProps || {}),
        startAdornment: startIcon
            ? (
                <InputAdornment position="start">
                    {React.cloneElement(startIcon, {
                        style: { width: 24, height: 24 },
                    })}
                </InputAdornment>
            )
            : inputProps?.startAdornment,
        endAdornment: endIcon
            ? (
                <InputAdornment position="end">
                    <IconButton
                        onClick={onEndIconClick}
                        edge="end"
                        size="small"
                    >
                        {React.cloneElement(endIcon, {
                            style: {
                                color: theme.palette.icon.main,
                                width: 24,
                                height: 24,
                            },
                        })}
                    </IconButton>
                </InputAdornment>
            )
            : inputProps?.endAdornment,
    }

    return (
        <TextFieldInputStyled
            type={type}
            label={label}
            error={error}
            value={value}
            variant="filled"
            onFocus={handleFocus}
            onBlur={handleBlur}
            helperText={error ? helperText : undefined}
            InputLabelProps={{
                shrink: (inputLabelProps && inputLabelProps.shrink !== undefined)
                    ? inputLabelProps.shrink
                    : hasValue || focus,
                className: startIcon ? "has-start-icon" : "",
                ...(inputLabelProps || {}),
            }}
            InputProps={mergedInputProps}
            inputProps={nativeInputProps}
            {...props}
        />
    )
}

TextFieldInput.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startIcon: PropTypes.element,
    endIcon: PropTypes.element,
    onEndIconClick: PropTypes.func,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    InputLabelProps: PropTypes.object,
    InputProps: PropTypes.object,
    inputProps: PropTypes.object,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
}

export default TextFieldInput
